import React, { useEffect, useState } from 'react'
import { SPECIAL_TICKETING_EVENTS } from '../../../../Constant/tickets'
import { SpecialEvent } from '../../../../Api'
import { getBroadcastImg, renderDateAndTime } from '../../../../Utils'
import { BroadcastCon, DescriptionName, ScheduleTableCon, TimeCol } from '../weekBox/weekStyles'
import { Img } from '../../../../Components/Image/Img'
import { BROADCASTER_LINKS } from '../../../../Config/config'
import { Lk } from '../../../../Components/Links/Lk'
import { SpecialEventsCon } from './styles'
import { Desc } from '../../../../Components/Typography/Text.styles'

type SpecialEventCalloutProps = {
  week: number
  showInET?: boolean
}

export const SpecialEventsCallout: React.FC<
  React.PropsWithChildren<SpecialEventCalloutProps>
> = ({ week, showInET }) => {
  const [specialEvents, setSpecialEvents] = useState<SpecialEvent[]>([])

  useEffect(() => {
    const specialEventsForWeek = SPECIAL_TICKETING_EVENTS.filter(
      (sp) => sp.week === week && evIsEnabled(sp)
    )
    setSpecialEvents(specialEventsForWeek)
  }, [week])

  const evIsEnabled = (event: SpecialEvent) => {
    const now = Date.now() / 1000
    const difference = now - event.startTime
    const THREE_WEEKS_IN_SECONDS = 1814400
    if (difference > THREE_WEEKS_IN_SECONDS) return false
    return true
  }

  const getSpecialEventName = (event: SpecialEvent) => {
    const now = Date.now() / 1000
    return event.showTime <= now ? event.description : event.hiddenDescription
  }

  return (
    <>
      {specialEvents.length > 0 && (
        <SpecialEventsCon>
          <Desc sideMargins={2}>Special Events</Desc>
          <ScheduleTableCon>
            <tbody>
              {specialEvents.map((event) => (
                <tr key={event.slugname}>
                  <td>
                    <TimeCol>
                      {event.timeString ??
                        renderDateAndTime(event.startTime, showInET, event.hideDate)}
                    </TimeCol>
                  </td>
                  <td align="left">
                    <DescriptionName>{getSpecialEventName(event)}</DescriptionName>
                  </td>
                  <td>
                    <BroadcastCon>
                      <Lk
                        link={event.urlStreaming || BROADCASTER_LINKS.generalESPNPlus}
                        alt="Broadcaster icons"
                      >
                        {getBroadcastImg(event.broadcaster).map((img, idx) => (
                          <Img
                            key={idx}
                            className="broadcaster"
                            src={img}
                            alt="broadcaster icons"
                          />
                        ))}
                      </Lk>
                    </BroadcastCon>
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </ScheduleTableCon>
        </SpecialEventsCon>
      )}
    </>
  )
}
